import posthog from 'posthog-js'

// PostHog utility to initialize based on environment
export const initPostHog = (username?: string) => {
  const hostname = window.location.hostname

  // Define your API keys for different environments
  const API_KEYS: { [key: string]: string } = {
    'staging.collabcampfire.com': 'phc_XI5aX8Yb8QbBihQyu8RAGxMBRkrTMxDVy6IZiVXdrgG',
    'app.collabcampfire.com': 'phc_laqBSj6YL5G6kWk4TFRjKC7mtYqfCDPUrby7SuyQuG6',
  }
  // If the hostname does not matches one of the environments, bail out.
  if (!API_KEYS[hostname]) {
    return
  }

  // Init Posthog
  posthog.init(API_KEYS[hostname], {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'always', // or 'identified_only' to not create profiles for anonymous users
  })

  // add username if user is logged in
  if (username) {
    posthog.identify(username)
  }
}
